<script>
import WithLoader from '@/components/WithLoader'
import AddDialog from './AddDialog.vue'

export default WithLoader(AddDialog, {
  events: ['add'],
  pendingProp: 'loading',
})
</script>
